<i18n src="./Login.txt" lang="yaml"></i18n>
<style src="./Login.scss" lang="scss"></style>
<script src="./Login.js"></script>

<template>
  <div
    class="
      login-register-area
      section-padding-1
      pt-50
      pb-100
    "
  >
    <div class="container">
      <div class="row login-register-row">
        <div class="col-lg-6 col-md-6" v-if="isLoginPage">
          <LoginForm />
          <a @click="isLoginPage = false"><u>{{ t('createAccount') }}</u></a>
        </div>
        <div class="col-lg-6 col-md-6" v-else>
          <SignUpForm />
          <a @click="isLoginPage = true"><u>{{ t('loginToExisting') }}</u></a>
        </div>
        <div class="col-lg-6 col-md-6 login-banner"  :style="`background-image:url(${require(`presentation/assets/img/banners/de/top-right.jpg`)});`">
        </div>
      </div>
    </div>
  </div>
</template>
